import React from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import { Divider, Flex, Link, Text } from "@chakra-ui/core";

const ShareSocialMedia = ({ hostname, ...rest }) => {
  const router = useRouter();

  // Safe to assume the website is always on HTTPS
  const currUrl = `https://${hostname}/${router.pathname}`;
  const safeUrl = encodeURIComponent(currUrl);

  return (
    <Flex direrction="row" {...rest}>
      <Text color="orchidGrey500">Share</Text>
      <Divider
        w="60px"
        flexGrow="1"
        mx="24px"
        mt="0.7em"
        orientation="horizontal"
        borderWidth="2px"
      />
      <Link
        href={`https://www.facebook.com/share.php?u=${safeUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        color="orchidGrey500"
        mr="24px"
      >
        Facebook
      </Link>
      <Link
        href={`https://twitter.com/intent/tweet?text=${safeUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        color="orchidGrey500"
      >
        Twitter
      </Link>
    </Flex>
  );
};

ShareSocialMedia.propTypes = {
  hostname: PropTypes.string,
};

export default ShareSocialMedia;
